import DOMPurify from "dompurify";

/**
 * Sanitize admin/workspace-configured HTML (e.g. the branding footer) before it is
 * injected via dangerouslySetInnerHTML. Uses DOMPurify with a conservative allowlist:
 * inline text formatting, links, and images only — no scripts, styles, iframes, forms,
 * or event handlers. Links are forced to open safely in a new tab.
 *
 * This is defense-in-depth: the content comes from a workspace admin (semi-trusted), but
 * the signing page is shown to external signers, so stored XSS must not be possible.
 */
export const sanitizeBrandingHtml = (html: string | null | undefined): string => {
  if (!html) return "";
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      "a",
      "b",
      "i",
      "em",
      "strong",
      "u",
      "br",
      "p",
      "span",
      "small",
      "div",
      "img",
    ],
    ALLOWED_ATTR: ["href", "title", "alt", "src", "width", "height"],
    ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto):|[^a-z]|[a-z+.-]+(?:[^a-z+.:-]|$))/i,
    ADD_ATTR: ["target", "rel"],
    FORBID_TAGS: ["script", "style", "iframe", "object", "embed", "form", "input"],
    FORBID_ATTR: ["onerror", "onload", "onclick"],
  });
};
